






























































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DatePicker from "@/components/DatePicker.vue";
import QuickSnack from "@/components/QuickSnack.vue";
import MoneyField from "@/components/MoneyField.vue";
import BetterThead from "@/components/BetterThead.vue";
import BetterHeaderFilter from "@/components/BetterHeaderFilter.vue";
import TxnEditDialog from "@/components/TxnEditDialog.vue";
import TxnReceiptDialog from "@/components/TxnReceiptDialog.vue";
import {
  domain,
  Company,
  Branch,
  PartialPermission,
  CARD_TYPES,
  TXFileType,
  getCardTypeName,
  TransactionQuery,
  TransactionQueryResult,
  TransactionExecuteResult,
  TransactionChange,
  VueForm,
  VueRoot,
  Terminal,
  CardTypeCode,
  Transaction
} from "@/domain";
import { TransactionItem, FilterData, Field } from "@/domain/types/transactions_query";
import {
  exportTransactionsExcel,
  getFieldDescriptors,
  fieldPriceColor,
  getTableData,
  filterTableData,
  setFilterValue,
  mapTransaction
} from "@/domain/transactions_query";
import { searchTerminal, selectCompany } from "@/domain/store_util";
import { calcTransactionTotals } from "@/domain/transaction_stats2";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import { AppError } from "@/domain/error";
import TxnInfoDialog, { TxnModifyEvent } from "@/components/TxnInfoDialog.vue";
import { sleepFor } from "@/util";
import TxnNewDialog from "@/components/TxnNewDialog.vue";
import ManualClose from "@/components/ManualClose.vue";
import TxnStadisticsDialog from "@/components/TxnStadisticsDialog.vue";

// Card brand slugs the Paytef transactionConsultation search API accepts for cardType -
// a fixed list agreed with the team, independent of brandDetails (used to detect the
// brand while typing a card number in the payment form, a different concern).
const cardTypeSearchOptions = [
  { value: "amex", text: "American Express" },
  { value: "bizum", text: "Bizum" },
  { value: "diners", text: "Diners Club" },
  { value: "maestro", text: "Maestro" },
  { value: "masterCard", text: "MasterCard" },
  { value: "mbway", text: "MB WAY" },
  { value: "visa", text: "Visa" }
];

@Component({
  components: {
    DatePicker,
    QuickSnack,
    MoneyField,
    TxnEditDialog,
    TxnReceiptDialog,
    TxnInfoDialog,
    BetterThead,
    BetterHeaderFilter,
    TxnNewDialog,
    TxnStadisticsDialog,
    ManualClose
  }
})
export default class TransactionQueryV3 extends Vue {
  isLoading = false;
  loadAllCancel = false;
  loadingAllGroups = false;
  loadingFile = "";
  filterPanel = true;
  showSummary = false;
  downloadMenu = { visible: false, x: 0, y: 0 };
  validFilters = true;
  tableData = getTableData<TransactionItem>();
  fieldDescriptors = getFieldDescriptors();

  // Dialog Modify Result
  modifiedTxnDialog = false;
  modifiedTxn: TransactionItem | null = null;
  // Data after query
  transactions: TransactionItem[] = [];
  transactionChanges: { [key: string]: TransactionChange } = {};
  lastResult: TransactionQueryResult[] = [];
  lastCompanyResult: TransactionQueryResult[] = [];
  lastQuery: QueryState = {
    multiPage: false,
    morePages: false,
    pageLoading: false,
    pageError: "",
    filters: null
  };
  // Retry Variables
  retryActive = false;
  timeToRetry = 10000;
  retryMax = 3;

  companySelectAll() {
    if (this.userCompanies.length === this.selCompanies.length) {
      this.selCompanies = [];
    } else {
      this.selCompanies = this.userCompanies;
    }
  }

  get cardTypeOptions() {
    return cardTypeSearchOptions;
  }

  // Filters
  txtFromDate = util.isoDateString();
  txtToDate = util.isoDateString();
  txtFromAmount = "";
  txtToAmount = "";
  txtReference = "";
  txtTransactionID = "";
  txtBin = "";
  selCardType: string | null = null;
  txtAuthCode = "";
  selBranch?: Branch | null = null;
  selBranchError = false;
  selTerminal?: Partial<Terminal> | null = null;

  // Multiple Companies
  selCompanyAll = this.lang.seeAllStores;
  selCompanies: Company[] | [] = [];
  selCompanyIndex = 0;
  selCompaniesNew = true;

  // Time
  useLocalTime = null;

  get snack() {
    return this.$refs.snack as QuickSnack;
  }

  onDialogMessage(content: { message: string; color: string }) {
    this.snack.show(content.message, content.color);
  }

  showError(text: string, err?: Partial<AppError> | unknown): string {
    const displayedText = uiUtil.toErrorMsg(err as AppError, text);
    this.snack.show(displayedText, "error");
    return displayedText;
  }

  get lang() {
    return this.$store.state.lang.data;
  }

  get langKey() {
    return this.$store.state.lang.key as string;
  }

  get userCompanies() {
    return this.$store.state.userCompanies;
  }

  get isLoadingAnything(): boolean {
    return this.isLoading || !!this.loadingFile || this.$store.state.selectedCompanyLoading;
  }

  get currentCompany(): Company | null {
    if (this.$store.state.selectedCompanyLoading) return null;
    return this.$store.state.selectedCompany;
  }

  get currentBranches(): Branch[] {
    return uiUtil.branchComboItems(this.currentCompany, this.userPermission, this.lang.allOffices);
  }

  get disableExcel() {
    if (this.currentCompany) {
      return !this.isValid() || !this.isDownloadEnabled;
    } else {
      return this.isDownloadEnabled;
    }
  }
  get disablePdf() {
    if (this.currentCompany) {
      return this.dateRangeInDays >= 45 || !this.isValid() || !this.isDownloadEnabled;
    } else {
      return false;
    }
  }

  get disableSearch() {
    if (this.currentCompany) {
      return !this.isValid() || this.isLoadingAnything;
    } else {
      return !this.selCompanies.length || this.dateRangeInDays > 31;
    }
  }

  get disableNewTxn() {
    if (this.currentCompany) return false;
    return true;
  }

  get timeOptions() {
    return [
      { name: "Hora de Procesamiento", value: false },
      { name: "Hora Local", value: true }
    ];
  }

  @Watch("useLocalTime")
  changeUseLocalTime() {
    localStorage.setItem("useLocalTime", JSON.stringify(this.useLocalTime));
  }

  @Watch("currentBranches")
  onBranchesChanged() {
    this.clearFilters();
    this.clearData();
  }

  get currentTerminals(): Partial<Terminal>[] {
    if (!this.selBranch || !this.selBranch.terminals || this.selBranch.terminals.length === 0) {
      return [];
    }
    return [{ code: "-1", name: "Todas las terminales", tcod: "" }, ...this.selBranch.terminals];
  }

  @Watch("currentTerminals")
  onTerminalsChanged() {
    this.selectTerminal(this.selTerminal?.code);
  }

  selectTerminal(code?: string, tcod?: string) {
    this.selTerminal = searchTerminal(this.selBranch, this.currentTerminals, code, tcod);
  }

  selectBranchAndTerminal(id?: number, code?: string, tcod?: string) {
    this.selBranch = util.selectOrNull(this.currentBranches, (b) => b.id === id);
    this.$nextTick(() => {
      this.selectTerminal(code, tcod);
    });
  }

  get userPermission(): PartialPermission {
    return this.$store.getters.userPermission;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  get transactionIDOrNull(): number | undefined {
    if (!this.txtTransactionID) {
      return undefined;
    }
    return 0;
  }

  get dateRules() {
    return [util.rules.required(this.lang.ruleValueRequired)];
  }

  get amountRules() {
    return [util.rules.numeric(this.lang.ruleNumericValue, true, true)];
  }

  get dateRangeInDays(): number {
    if (!this.txtFromDate || !this.txtToDate) {
      return 0;
    }
    return Math.abs(util.parseISODate(this.txtToDate).diff(util.parseISODate(this.txtFromDate), "day")) + 1;
  }

  showStadistics() {
    const filters = this.getFilters();
    (this.$refs.stadistics as TxnStadisticsDialog).open(this.tableData.data, {
      companyName: this.currentCompany?.name || "",
      branchName: this.selBranch?.name || "",
      from: filters?.from || "",
      to: filters?.to || ""
    });
  }

  @Watch("txtFromDate")
  onFromDateChanged(newValue: string) {
    // Change ToDate if From Date is bigger
    if (!!newValue && newValue.localeCompare(this.txtToDate) > 0) {
      this.txtToDate = newValue;
    }
  }

  @Watch("txtToDate")
  onToDateChanged(newValue: string) {
    if (!!newValue && newValue.localeCompare(this.txtFromDate) < 0) {
      this.txtFromDate = newValue;
    }
  }

  get selBranchRules() {
    return [
      (value: Branch | null) => {
        if (!this.txtTransactionIDOrNull || (!!value && value.id !== -1)) {
          this.selBranchError = false;
          return true;
        }
        this.selBranchError = true;
        return this.lang.selectOfficeToFilter;
      }
    ];
  }

  onItemsChange() {
    this.$nextTick(() => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const otherItems = (this.$refs.txnTable as any).$children[0].filteredItems;
      this.tableData.data = otherItems || [];
    });
  }

  get filteredStats() {
    return calcTransactionTotals(this.tableData.data);
  }

  getBranchID(branch?: Branch): number | undefined {
    if (!branch || branch.id === -1) {
      return undefined;
    }
    return branch.id;
  }

  getCardType(cardTypeCode: CardTypeCode): string {
    return getCardTypeName(cardTypeCode);
  }

  updateCardTypeOptions() {
    const filter = this.tableData.filters.cardTypeCode;
    if (!filter) return;
    const keys = util.collectUnique(this.transactions, "cardTypeCode");
    const ccTypes = util.collectTextValue(keys, CARD_TYPES, this.lang.withoutCard);
    if (filter.tList) {
      filter.tList.options = ccTypes;
      filter.value = (filter.tList.options || []).map((t) => t.value);
    }
  }

  isValid(): boolean {
    // Multiple Companies
    if (!this.currentCompany) {
      return !this.$refs.filterForm || this.validateFilterForm();
    }
    return !!this.currentCompany && !!this.selBranch && (!this.$refs.filterForm || this.validateFilterForm());
  }

  validateFilterForm(): boolean {
    if (!this.$refs.filterForm) {
      return true;
    }
    return (this.$refs.filterForm as VueForm).validate();
  }

  async created() {
    this.selCompanies = this.userCompanies;
    if (this.$route.query && this.$route.query.companyID && this.$route.query.branchID) {
      this.$nextTick(() => {
        this.chooseBranchAndTerminal();
      });
    } else {
      if (this.currentBranches.length > 0) {
        this.selBranch = this.currentBranches[0];
      }
    }
    // useLocalTime
    this.useLocalTime = JSON.parse(localStorage.getItem("useLocalTime") || "false");
  }

  async chooseBranchAndTerminal() {
    await selectCompany(this.$store, this.$route.query.companyID);
    this.selectBranchAndTerminal(
      util.toNumber(this.$route.query.branchID),
      this.$route.query.terminalID as string | undefined,
      this.$route.query.tcod as string | undefined
    );
  }

  get txtTransactionIDOrNull(): number | undefined {
    return util.toNumberID(this.txtTransactionID);
  }

  get isDownloadEnabled(): boolean {
    return (
      !this.isLoadingAnything &&
      !!this.lastQuery.filters &&
      util.objEquals(this.lastQuery.filters, this.getRawFilters(), ["pageNum"])
    );
  }

  getAllCompaniesFilters(id: number): TransactionQuery {
    const filters: TransactionQuery = {
      companyID: id,
      branchID: undefined,
      tcod: undefined,
      from: this.txtFromDate,
      to: this.txtToDate,
      reference: this.txtReference,
      transactionID: this.txtTransactionIDOrNull,
      pageNum: 1,
      language: this.langKey
    };
    return filters;
  }

  setCompanyIdFilter(id: number) {
    if (this.lastQuery.filters) this.lastQuery.filters.companyID = id;
  }

  getRawFilters(): TransactionQuery | null {
    if (this.$store.state.selectedCompany) {
      //ONE COMPANY FILTERS
      if (!this.currentCompany || !this.selBranch) return null;
      const tcod = this.selTerminal?.tcod;
      const filters: TransactionQuery = {
        companyID: this.currentCompany.id,
        branchID: this.selBranch.id === -1 ? undefined : this.selBranch.id,
        tcod: !tcod ? undefined : tcod,
        from: this.txtFromDate,
        to: this.txtToDate,
        reference: this.txtReference,
        transactionID: this.txtTransactionIDOrNull,
        bin: this.txtBin || undefined,
        cardType: this.selCardType || undefined,
        authCode: this.txtAuthCode || undefined,
        pageNum: 1,
        useLocalTime: this.useLocalTime || false,
        language: this.langKey
      };
      if (!util.isEmpty(this.txtFromAmount)) {
        filters.amountFrom = Number(this.txtFromAmount);
      }
      if (!util.isEmpty(this.txtToAmount)) {
        filters.amountTo = Number(this.txtToAmount);
      }
      return filters;
    } else {
      // Multiple Companies FILTERS
      const filters: TransactionQuery = {
        companyID: 0,
        branchID: undefined,
        tcod: undefined,
        from: this.txtFromDate,
        to: this.txtToDate,
        reference: this.txtReference,
        transactionID: this.txtTransactionIDOrNull,
        bin: this.txtBin || undefined,
        cardType: this.selCardType || undefined,
        authCode: this.txtAuthCode || undefined,
        pageNum: 1,
        useLocalTime: this.useLocalTime || false,
        language: this.langKey
      };
      return filters;
    }
  }

  getFilters(): TransactionQuery | null {
    if (this.txtFromDate.localeCompare(this.txtToDate) > 0) {
      // Flip dates if "from" is bigger than "to"
      const d = this.txtFromDate;
      this.txtFromDate = this.txtToDate;
      this.txtToDate = d;
    }
    return this.getRawFilters();
  }

  get newCompany() {
    return this.selCompaniesNew;
  }

  get resultStats() {
    let result;
    if (this.currentCompany) {
      // ONE COMPANY STATS
      result = {
        pagesLoaded: this.lastResult.length,
        transactionCount: this.lastResult.map((r) => Number((r.transactions || []).length)).reduce((p, c) => p + c, 0),
        morePages: this.lastQuery.morePages,
        intervalDays: Math.ceil(this.intervalDays()),
        percent: 0,
        companyPorc: 0,
        currentCompanyName: ""
      };
      result.percent = this.calcResultPercent(result.intervalDays);
    } else {
      // MULTIPLE COMPANY STATS
      result = {
        companiesLoaded: this.selCompanyIndex,
        pagesLoaded: this.lastResult.length,
        transactionCount: this.lastResult.map((r) => Number((r.transactions || []).length)).reduce((p, c) => p + c, 0),
        morePages: this.lastQuery.morePages,
        intervalDays: Math.ceil(this.intervalDays()),
        percent: 0,
        currentCompanyPorc: 0,
        currentCompanyName: ""
      };
      const i = this.selCompanyIndex;
      result.currentCompanyName = this.selCompanies[i] ? this.selCompanies[i].name : "";
      result.currentCompanyPorc = this.newCompany ? 0 : this.calcResultPercent(result.intervalDays);
      result.percent = Math.ceil(
        (result.companiesLoaded / this.selCompanies.length) * 100 +
        (1 / this.selCompanies.length) * result.currentCompanyPorc
      );
    }
    return result;
  }

  openNewTransaction() {
    if (this.currentCompany) {
      (this.$refs.txnNewDialog as TxnNewDialog).open(this.currentBranches, this.currentCompany.id);
    }
  }

  openManualClose() {
    if (this.currentCompany) {
      (this.$refs.manualClose as ManualClose).open(
        this.currentBranches,
        this.currentCompany.id,
        this.selBranch?.id ?? null,
        this.selTerminal?.tcod ?? null
      );
    }
  }

  canModify(): boolean {
    return this.userPermission.txnModification;
  }

  intervalDays(): number {
    if (!this.lastQuery.filters || this.lastResult.length === 0) {
      return 0;
    }
    return (
      util.parseISODate(this.lastQuery.filters.to).diff(util.parseISODate(this.lastQuery.filters.from), "day") + 1.0
    );
  }

  calcResultPercent(totalDays: number): number {
    if (totalDays <= 0 || !this.lastQuery.filters) {
      return 100;
    }
    try {
      const pageResult = this.lastResult[this.lastResult.length - 1];
      if (!pageResult.morePages) {
        return 100;
      }
      let maxDate = "0";
      pageResult.transactions.forEach((tx) => {
        if (tx.timestamp && (tx.timestamp || "0").localeCompare(maxDate) > 0) {
          maxDate = tx.timestamp;
        }
      });
      if (maxDate === "0") {
        util.logError("Error calculating result percent: maxDate not found", pageResult);
        return 0;
      }
      const elapsedHours = util.parseISODate(maxDate).diff(util.parseISODate(this.lastQuery.filters.from), "hours");
      return Math.floor((elapsedHours * 100) / (totalDays * 24));
    } catch (ex) {
      util.logError("Error calculating result percent", ex);
    }
    return 0;
  }

  clearFilters() {
    this.txtFromDate = util.isoDateString();
    this.txtToDate = util.isoDateString();
    this.txtFromAmount = "";
    this.txtToAmount = "";
    this.txtReference = "";
    this.txtTransactionID = "";
    this.txtBin = "";
    this.selCardType = null;
    this.txtAuthCode = "";
    this.selectBranchAndTerminal(this.selBranch?.id, this.selTerminal?.code);
    this.validateFilterForm();
  }

  clearData() {
    this.transactions = [];
    this.transactionChanges = {};
    this.tableData.data = [];
    this.lastResult = [];
    filterTableData(this.tableData, this.transactions);
    this.lastQuery = {
      morePages: false,
      multiPage: false,
      pageLoading: false,
      pageError: "",
      filters: this.getFilters()
    };
  }

  async filterList(): Promise<boolean> {
    if (this.txtTransactionID) this.tableData = getTableData<TransactionItem>(true);
    this.clearData();
    if (this.$store.state.selectedCompany) {
      // ONE COMPANY
      if (!this.isValid()) {
        this.showError(this.lang.errorSelectParams);
        return false;
      }
      let success = await this.queryOnePage();
      if (success && this.lastQuery.morePages) {
        success = !!(await this.getAllPages());
      }
      return success;
    }
    // MULTIPLES COMPANIES
    this.loadingAllGroups = true;
    this.loadAllCancel = false;
    this.selCompanyIndex = 0;
    let success;
    do {
      this.selCompaniesNew = true;
      this.lastCompanyResult = [];
      this.resetFilters();
      success = await this.queryOnePage();
      if (success && this.lastQuery.morePages) {
        success = !!(await this.getAllPages());
      }
      if (!this.loadAllCancel) this.selCompanyIndex = this.selCompanyIndex + 1;
      this.selCompaniesNew = false;
    } while (this.selCompanyIndex < this.selCompanies.length && !this.loadAllCancel);
    this.loadingAllGroups = false;
    if (!this.loadAllCancel) this.selCompanyIndex = 0;
    return success;
  }

  async getAllPages(retryCount = this.retryMax): Promise<boolean> {
    this.loadAllCancel = false;
    this.loadingAllGroups = true;
    if (!this.lastQuery.morePages) {
      return true;
    }
    try {
      let loadSuccess = false;
      do {
        loadSuccess = await this.getNextPage();
      } while (loadSuccess && !this.loadAllCancel && this.lastQuery.morePages);
    } catch (ex) {
      // RETRY GET ALL PAGES ON ERROR
      if (retryCount > 0) {
        await sleepFor(this.timeToRetry);
        return await this.getAllPages(retryCount - 1);
      } else {
        util.logError(this.lang.errorLoadPage, ex);
        if (!this.lastQuery.pageError) {
          this.lastQuery.pageError = this.showError(this.lang.errorUnexpected, ex);
        }
      }
    }
    if (this.$store.state.selectedCompany) this.loadingAllGroups = false;
    return !this.lastQuery.morePages;
  }

  async resumeDownload() {
    if (this.$store.state.selectedCompany) {
      return await this.getAllPages();
    }
    await this.getAllPages();
    this.selCompanyIndex = this.selCompanyIndex + 1;
    if (this.selCompanyIndex >= this.selCompanies.length) {
      this.loadingAllGroups = false;
      return true;
    }
    this.loadAllCancel = false;
    let success;
    do {
      this.selCompaniesNew = true;
      this.lastCompanyResult = [];
      this.resetFilters();
      success = await this.queryOnePage();
      if (success && this.lastQuery.morePages) {
        success = !!(await this.getAllPages());
      }
      this.selCompanyIndex = this.selCompanyIndex + 1;
      this.selCompaniesNew = false;
    } while (this.selCompanyIndex < this.selCompanies.length && !this.loadAllCancel);
    this.loadingAllGroups = false;
    if (!this.loadAllCancel) this.selCompanyIndex = 0;
    return success;
  }

  async getNextPage(): Promise<boolean> {
    if (!this.lastQuery.filters) {
      this.showError(this.lang.errorMissingFilters);
      return false;
    }
    if (!this.lastQuery.morePages) {
      return false;
    }
    if (!this.lastQuery.pageError) {
      if (this.lastQuery.morePages) {
        if (this.$store.state.selectedCompany) {
          this.lastQuery.filters.pageNum = this.lastResult.length + 1;
        } else {
          this.lastQuery.filters.pageNum = this.lastCompanyResult.length + 1;
        }
      }
    }
    return this.queryOnePage();
  }

  async queryOnePage(): Promise<boolean> {
    const company: Company | null = this.$store.state.selectedCompany ? null : this.selCompanies[this.selCompanyIndex];
    this.isLoading = true;
    try {
      if (!this.lastQuery.filters) {
        this.showError(this.lang.errorMissingFilters);
        this.isLoading = false;
        return false;
      }
      //Set filters in multiple companies
      if (company) this.setCompanyIdFilter(company.id);

      const result = await domain.backend.getTransactionData(this.lastQuery.filters);
      this.selCompaniesNew = false;
      // Add company data
      const transactionWithCompany: Transaction[] = [];
      result.transactions.forEach((transaction: Transaction): void => {
        const companyId = company ? company.id : this.$store.state.selectedCompany.id;
        const companyName = company ? company.name : this.$store.state.selectedCompany.name;
        transactionWithCompany.push({ ...transaction, company: companyName, companyId });
      });
      result.transactions = transactionWithCompany;
      const mappedTransactions = result.transactions.map(mapTransaction);
      this.transactions = [...this.transactions, ...mappedTransactions];
      this.updateCardTypeOptions();
      if (result.transactionChanges) {
        result.transactionChanges.forEach((txc) => {
          this.transactionChanges["t" + txc.newTxnID] = txc;
        });
      }
      this.tableData.data = this.transactions;
      this.lastResult.push(result);
      // Array of current company results
      this.lastCompanyResult.push(result);
      this.lastQuery.morePages = !!result.morePages;
      if (this.lastQuery.filters.pageNum === 1) {
        this.lastQuery.multiPage = this.lastQuery.morePages;
      }
      this.filterPanel = false;
    } catch (err) {
      util.logError("Error filtering transactions", err);
      this.lastQuery.pageError = this.showError(this.lang.errorTryAgain, err);
    }
    filterTableData(this.tableData, this.transactions);
    this.isLoading = false;
    // Return multiple companies
    if (company) return this.lastCompanyResult.length === this.lastQuery.filters?.pageNum;
    // Return one company
    return this.lastResult.length === this.lastQuery.filters?.pageNum;
  }

  onFilterInput(filter: FilterData, newValue: string | string[]) {
    setFilterValue(filter, newValue);
  }

  resetFilters() {
    this.lastQuery = {
      morePages: false,
      multiPage: false,
      pageLoading: false,
      pageError: "",
      filters: this.getFilters()
    };
  }

  showPdfMenu(e: MouseEvent) {
    e.preventDefault();
    if (this.currentCompany) {
      this.downloadMenu = { visible: false, x: e.clientX, y: e.clientY };
      this.$nextTick(() => {
        this.downloadMenu.visible = true;
      });
    } else {
      this.snack.show(this.lang.errorPdfFormatNotAvailable, "warning");
    }
  }

  async downloadFile(fileType: TXFileType) {
    if (!this.isValid()) {
      this.snack.show(this.lang.selectFiltersToDownload, "warning");
      return;
    }
    this.loadingFile = fileType;
    try {
      const filters = this.getFilters();
      if (filters === null) {
        this.showError(this.lang.errorCheckFilters);
        return;
      }
      await domain.backend.downloadTxnFile(
        {
          companyID: filters.companyID,
          branchID: filters.branchID,
          tcod: filters.tcod,
          from: filters.from,
          to: filters.to,
          reference: filters.reference,
          language: this.langKey
        },
        this.currentCompany?.name || "-",
        this.selBranch?.name || "-",
        fileType
      );
      this.snack.show(this.lang.successFileGenerated, "success");
    } catch (err) {
      util.logError("Error download file", err);
      this.showError(this.lang.errorDownloadingFile, err);
    }
    this.loadingFile = "";
  }

  async cmdExportExcel(retry = true) {
    const filteredTransactions = this.tableData.data;
    // No results.
    if (filteredTransactions.length == 0) {
      this.snack.show(this.lang.noResults, "warning");
      return;
    }
    if (this.lastQuery.morePages) {
      if (!(await this.getAllPages())) {
        return;
      }
    }
    if (filteredTransactions && filteredTransactions.length > 0) {
      try {
        const filters = this.getFilters();
        if (filters === null) {
          this.showError(this.lang.errorCheckFilters);
          return;
        }
        const newFieldDescription: Field[] = [];
        this.fieldDescriptors.forEach((e): void => {
          if (this.currentCompany && e.field !== "company") newFieldDescription.push(e);
          if (!this.currentCompany) newFieldDescription.push(e);
        });
        await exportTransactionsExcel(filteredTransactions, newFieldDescription, {
          companyName: this.currentCompany?.name || "-",
          branchName: this.selBranch?.name || "-",
          from: filters.from,
          to: filters.to
        });
      } catch (err) {
        util.logError("Error escribiendo excel", err);
        this.showError(this.lang.errorGeneratingFile, err);
      }
      return;
    }
    if (!this.lastQuery.filters && retry) {
      try {
        const isSuccess = await this.filterList();
        if (isSuccess) {
          util.promiseEnd(this.cmdExportExcel(false));
        }
      } catch (err) {
        util.logError("Error consultando las transacciones", err);
        this.showError(this.lang.errorQueryTransactions, err);
      }
      return;
    }
    this.snack.show(this.lang.noResults, "warning");
  }

  infoItem(item: TransactionItem) {
    (this.$refs.infoDialog as TxnInfoDialog).clearTxn();
    (this.$refs.infoDialog as TxnInfoDialog).showItem(item);
  }

  showReceipt(item: TransactionItem) {
    (this.$refs.receiptDialog as TxnReceiptDialog).showReceipt(item);
  }

  txnModify(evt: TxnModifyEvent) {
    (this.$refs.txnEditDialog as TxnEditDialog).openForEdit(evt.txn, evt.opType, evt.confirmKeyword, evt.bizum);
  }

  onTransactionSaved(savedTxn: TransactionExecuteResult) {
    util.log("Transaction", savedTxn);
    const txnItem = mapTransaction(savedTxn.transaction);
    this.modifiedTxn = txnItem;
    this.modifiedTxnDialog = true;
  }

  priceColor(item: Partial<TransactionItem> | number | string | undefined): string {
    return fieldPriceColor(item);
  }
}

interface QueryState {
  filters: TransactionQuery | null;
  multiPage: boolean;
  morePages: boolean;
  pageLoading: boolean;
  pageError: string;
}
